const ALL_WEEKDAYS = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"] as const

import { WEEKDAYS } from "~/utils/replenishmentRules"

export function rruleDayToWeekday(day: string): string {
  return WEEKDAYS[(ALL_WEEKDAYS as readonly string[]).indexOf(day)] ?? day
}

export function weekdayToRruleDay(day: string): string {
  return ALL_WEEKDAYS[(WEEKDAYS as readonly string[]).indexOf(day)] ?? day
}
